import { SettlementEntryOrderField } from 'api/graphql/generated/graphql';
import { LISTING_RECORDS_PER_PAGE } from 'pages/platform/constants';

import { IPayoutBreakdownFilterObj, IPayoutBreakdownFilterObjError, IPayoutBreakdownPageObj } from './types';

export const getPayoutBreakdownInitialFilterState = (): IPayoutBreakdownFilterObj => {
  return {
    amountChecked: false,
    amount: null,
    entryTypeChecked: false,
    entryType: null,
    transactionIdChecked: false,
    transactionId: null,
    payoutIdChecked: false,
    payoutId: null,
    createdOnChecked: false,
    createdOn: null,
    availableOnChecked: false,
    availableOn: null,
  };
};

export const getInitialErrorState = (): IPayoutBreakdownFilterObjError => {
  return {
    amountError: '',
    entryTypeError: '',
    transactionIdError: '',
    payoutIdError: '',
    createdOnError: '',
    availableOnError: '',
  };
};

export const getPayoutBreakdownInitialPageState = (): IPayoutBreakdownPageObj => {
  return {
    page: 1,
    last: null,
    before: null,
    first: LISTING_RECORDS_PER_PAGE,
    after: null,
    orderBy: {
      ascending: false,
      field: SettlementEntryOrderField.CreatedAt,
    },
  };
};
